"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _contentType = require("@insided/shared/utils/contentType");

var _common = require("@insided/shared/utils/common");

var _TopicLikeButtonView = _interopRequireDefault(require("./TopicLikeButtonView"));

var _TopicVoteButtonView = _interopRequireDefault(require("./TopicVoteButtonView"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicLikeVoteButtonView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicLikeVoteButtonView, _Component);

  var _super = _createSuper(TopicLikeVoteButtonView);

  function TopicLikeVoteButtonView() {
    var _this;

    (0, _classCallCheck2.default)(this, TopicLikeVoteButtonView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hasCurrentUserLiked: _this.props.hasCurrentUserLiked,
      likesOrVotesCount: _this.props.contentType === 'idea' ? _this.props.votes : _this.props.likes
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "likeTopicHandler", function () {
      var _this$props = _this.props,
          isGuest = _this$props.isGuest,
          contentType = _this$props.contentType,
          topicId = _this$props.topicId;
      var _this$state = _this.state,
          hasCurrentUserLiked = _this$state.hasCurrentUserLiked,
          likesOrVotesCount = _this$state.likesOrVotesCount;
      var actionType = hasCurrentUserLiked ? 'unlike' : 'like';

      if (isGuest) {
        var event = new CustomEvent('GuestUserAction');
        window.dispatchEvent(event);
        return;
      }

      _this.setState({
        hasCurrentUserLiked: !hasCurrentUserLiked,
        likesOrVotesCount: likesOrVotesCount + (!hasCurrentUserLiked ? 1 : -1)
      });

      if (contentType === 'idea' && _common.common.isModuleActive('ideationV2')) {
        actionType = hasCurrentUserLiked ? 'unvote' : 'vote';
      }

      _axios.default.post("/community/api/".concat((0, _contentType.getConsistentContentType)(contentType), "s/").concat(topicId, "/").concat(actionType));
    });
    return _this;
  }

  (0, _createClass2.default)(TopicLikeVoteButtonView, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          hasCurrentUserLiked = _this$state2.hasCurrentUserLiked,
          likesOrVotesCount = _this$state2.likesOrVotesCount;
      var contentType = this.props.contentType;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      var showVoteButton = contentType === 'idea' || contentType === 'conversation' && isBugContentTypeEnabled;

      if (showVoteButton) {
        return (0, _preact.h)(_TopicVoteButtonView.default, {
          hasVoted: hasCurrentUserLiked,
          count: likesOrVotesCount,
          onClick: this.likeTopicHandler
        });
      }

      return (0, _preact.h)(_TopicLikeButtonView.default, {
        hasVoted: hasCurrentUserLiked,
        count: likesOrVotesCount,
        onClick: this.likeTopicHandler
      });
    }
  }]);
  return TopicLikeVoteButtonView;
}(_preact.Component);

var _default = TopicLikeVoteButtonView;
exports.default = _default;